import React, { useState, useEffect } from "react";
import {
  Nav,
  NavbarContainer,
  HamburgerIcon,
  NavMenu,
  NavItemBtn,
  NavBtnLink,
  PublicNav,
  PublicNavInner,
  PublicBrand,
  PublicCenter,
  CountryPill,
  PublicNavGroup,
  PublicTrigger,
  PublicNavLink,
  PublicAnchor,
  PublicLanguage,
  PublicActions,
  PublicHeaderLanguage,
  PublicDesktopOnly,
  PublicCta,
  PublicHamburger,
  PublicMobilePanel,
  PublicMobileMenu,
  PublicLanguageToggleGroup,
  PublicLanguageToggle,
  PublicMobileLink,
  PublicMobileAnchor,
  PublicBackButton,
  MobileCountryToggle,
  MobileCountryList,
  MobileCountryLink,
} from "./Navbar.elements";
import { FaTimes, FaBars, FaArrowLeft } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { MainButton, OutlineButton } from "../../globalStyles";

import Logo from "../../images/e-citizen_logo_ecitizen.png";
import LogoWhite from "../../images/e-citizen_logo_ecitizen_white.png";
import defaultDp from "../../images/defaultDp.png";
import defaultDpDark from "../../images/defaultDpDark.png";
import { Link, useLocation } from "react-router-dom";
import { Button, Flex, Modal, Radio, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { logout, fetchUserProfile } from "../../redux/actions";
import { useHistory } from "react-router-dom";
import { Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Menu, Dropdown, Space, Divider, Input } from "antd";
import paypal from "../../images/paypal.png";
import Swal from "sweetalert2";
import { ThemeToggle } from "../../components/ThemeToggle";
import { theme } from "antd";
import { useTheme } from "../../components/ThemeProvider";
import baseUrl from "../../apiConfig";
import { imageBaseUrl } from "../../apiConfig";
import axios from "axios"; // Import axios
import { initiatePaystackPayment } from "../../services/paystackService";
import { withAnalyticsMetadata } from "../../analytics/attribution";
import {
  trackAnalyticsEvent,
  trackPurchaseConversion,
} from "../../hooks/analytics";

const { useToken } = theme;

const { Title } = Typography;

// NOTE: this list intentionally excludes Nigeria (the current site).
// Update the hrefs below if the real country-specific domains differ.
const OTHER_COUNTRIES = [
  {
    key: "country-ghana",
    flag: "🇬🇭",
    label: "Ghana",
    href: "https://e-citizen.africa/gh",
  },
  {
    key: "country-kenya",
    flag: "🇰🇪",
    label: "Kenya",
    href: "https://e-raia.com/ke",
  },
  {
    key: "country-uganda",
    flag: "🇺🇬",
    label: "Uganda",
    href: "https://e-raia.com/ug",
  },
  {
    key: "country-civ",
    flag: "🇨🇮",
    label: "Côte d'Ivoire",
    href: "https://citoyen.africa/ci",
  },
];

function Navbar() {
  const history = useHistory();
  const location = useLocation();
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const userDetails = useSelector((state) => state.userDetails);
  const userToken = userDetails?.jwtToken || "";

  // const tokenExpire = userDetails?.expirationDate || "";
  const userCurrency = userDetails?.currency || "";
  const user = useSelector((state) => state.user);
  const userToken2 = user?.jwtToken || "";
  // const tokenExpire = "2024-04-30T09:04:44.000+00:00";

  const tokenExpire = user?.expirationDate || "";

  const handleClick = () => setClick(!click);

  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    // Correct the typo from innerwidth to innerWidth
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    // Convert tokenExpire string to a Date object
    const expireDate = new Date(tokenExpire);

    // Get the current date/time
    const currentDate = new Date();

    if (currentDate >= expireDate) {
      dispatch(logout());
      history.push("/");
    } else {
    }
  }, []);

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);
  const handleLogout = () => {
    // Dispatch the logout action when the user clicks the logout button
    dispatch(logout());
    history.push("/");
  };

  const handleGoBack = () => {
    if (history.length > 1) {
      history.goBack();
      return;
    }

    history.push("/");
  };

  const isVerificationLogin = location.pathname === "/verification-login";

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <a href="/main-dashboard" style={{ textDecoration: "none" }}>
    //       Dashboard
    //     </a>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Link to="/profile" style={{ textDecoration: "none" }}>
          My Profile
        </Link>
      ),
    },
    {
      key: "3",
      label: <span onClick={handleLogout}>Logout</span>,
    },
  ];
  const [visible, setVisible] = useState(false);
  const [mobileCountryOpen, setMobileCountryOpen] = useState(false);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  // Authenticated user dropdown menu (profile / logout / switch country / theme)
  const menu = (
    <Menu>
      {items.map((item) => (
        <Menu.Item key={item.key} onClick={closeMobileMenu}>
          {item.label}
        </Menu.Item>
      ))}
      <Menu.Divider />
      <Menu.SubMenu
        key="country-selector"
        title={
          <span>
            <span
              role="img"
              aria-label="Nigeria flag"
              style={{ marginRight: 8 }}
            >
              🇳🇬
            </span>
            Nigeria
          </span>
        }
      >
        {OTHER_COUNTRIES.map((country) => (
          <Menu.Item key={country.key}>
            <a
              href={country.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <span
                role="img"
                aria-label={`${country.label} flag`}
                style={{ marginRight: 10 }}
              >
                {country.flag}
              </span>
              {country.label}
            </a>
          </Menu.Item>
        ))}
      </Menu.SubMenu>
      <Menu.Item key="theme-toggle" onClick={closeMobileMenu}>
        <ThemeToggle />
      </Menu.Item>
    </Menu>
  );

  const UserDropdown = () => {
    return (
      <Dropdown
        overlay={menu}
        trigger={["click"]}
        visible={visible}
        onVisibleChange={handleVisibleChange}
        placement="bottomLeft"
        arrow
      >
        <Space
          key="user-dropdown"
          style={{
            cursor: "pointer",
            border: "1px solid #d9d9d9",
            padding: "8px",
            borderRadius: "8px", // Set borderRadius to make it a square
          }}
          size={20}
        >
          <img
            src={
              userDetails && userDetails?.profileImageLocation
                ? `${imageBaseUrl}${userDetails?.profileImageLocation}`
                : isDark
                  ? defaultDpDark
                  : defaultDp
            }
            alt="User Avatar"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "8px",
            }}
          />
          <DownOutlined />
        </Space>
      </Dropdown>
    );
  };

  // Public (logged-out) header dropdowns
  const servicesMenu = (
    <Menu>
      <Menu.Item key="services-nin">
        <Link to="/nin-verification" style={{ textDecoration: "none" }}>
          NIN Verification
        </Link>
      </Menu.Item>
      <Menu.Item key="services-phone">
        <Link
          to="/phone-number-verification"
          style={{ textDecoration: "none" }}
        >
          Phone Number Verification
        </Link>
      </Menu.Item>
      <Menu.Item key="services-business">
        <Link to="/business-verification" style={{ textDecoration: "none" }}>
          Business Profile Verification
        </Link>
      </Menu.Item>
      <Menu.Item key="services-credit">
        <Link to="/credit-profile" style={{ textDecoration: "none" }}>
          Financial Credit Verification
        </Link>
      </Menu.Item>
      <Menu.Item key="services-vin">
        <Link to="/vehicle-verification" style={{ textDecoration: "none" }}>
          Vehicle History Verification
        </Link>
      </Menu.Item>
    </Menu>
  );

  const countryMenu = (
    <Menu>
      {OTHER_COUNTRIES.map((country) => (
        <Menu.Item key={country.key}>
          <a
            href={country.href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <span
              role="img"
              aria-label={`${country.label} flag`}
              style={{ marginRight: 10 }}
            >
              {country.flag}
            </span>
            {country.label}
          </a>
        </Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    // Dispatch fetchUserProfile action when component mounts
    dispatch(fetchUserProfile(userToken));
  }, [dispatch]);

  const userBalance = userDetails?.walletBalance || 0;
  const formatToNaira = (value) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(value);
  };
  const formatToDollar = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };
  const [amount, setAmount] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modal1Open, setModal1Open] = useState(false);
  const [openPaystackModal, setOpenPaystackModal] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [transactionRef, setTransactionRef] = useState("");
  const [paystackReference, setPaystackReference] = useState("");
  const [walletPaymentMethod, setWalletPaymentMethod] = useState(1);
  const [paystackLoading, setPaystackLoading] = useState(false);
  const [transactionAmount, setTransactionAmount] = useState(0);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setAmount("");
    setIsModalVisible(false);
  };
  const handleModalOk = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/payment/check?transactionRef=${transactionRef}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken2}`,
          },
        },
      );

      if (response.ok) {
        const responseData = await response.json();
        if (responseData.status === "success") {
          // Track conversion
          trackPurchaseConversion({
            value: parseFloat(transactionAmount) || 1.0,
            currency: userCurrency || "NGN",
            transactionId: transactionRef,
          });
          dispatch(fetchUserProfile(userToken2));
          setModal1Open(false);
        } else {
          dispatch(fetchUserProfile(userToken2));
          setModal1Open(false);
        }
      }
    } catch (error) {
      dispatch(fetchUserProfile(userToken2));
      setModal1Open(false);
    }
    // dispatch(fetchUserProfile(userToken2));
    // setModal1Open(false);
  };

  const handlePaystackModalClose = async () => {
    setOpenPaystackModal(false);

    try {
      const response = await fetch(
        `${baseUrl}/payment/check-pulse?transactionRef=${paystackReference}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken2}`,
          },
        },
      );

      // Check if the request was successful (status code 200-299)
      if (!response.ok) {
        Swal.fire({
          background: bgContainer,
          color: text,
          title: "Error",
          text: "Payment Cancelled or Declined",
          icon: "error",
          customClass: {
            confirmButton: "custom-swal-button",
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
          confirmButtonText: "OK",
          confirmButtonColor: "#0DC939",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
        return;
      }
      if (response.ok) {
        const responseData = await response.json();
        if (
          responseData.data.status === "successful" ||
          responseData.status === "success"
        ) {
          if (
            responseData.data &&
            (responseData.data.status === "success" ||
              responseData.data.status === "successful")
          ) {
            // Payment successful - track conversion and refresh profile
            trackPurchaseConversion({
              value: parseFloat(transactionAmount) || 1.0,
              currency: userCurrency || "NGN",
              transactionId: paystackReference,
            });
            dispatch(fetchUserProfile(userToken2));
          } else {
            Swal.fire({
              background: bgContainer,
              color: text,
              title: "Failed Payment",
              text: responseData.data.processor_response,
              icon: "error",
              customClass: {
                confirmButton: "custom-swal-button",
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: "#0DC939",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
            return;
          }
        }
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Error",
        text: "There was an issue making payment",
        icon: "error",
        customClass: {
          confirmButton: "custom-swal-button",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
        confirmButtonText: "OK",
        confirmButtonColor: "#0DC939",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      return;
    }
  };

  // Auto-close FlutterWave modal when payment reaches a terminal state
  useEffect(() => {
    if (!modal1Open || !transactionRef) return;
    const TERMINAL = [
      "successful",
      "success",
      "failed",
      "cancelled",
      "error",
      "reversed",
    ];
    let handled = false;
    const intervalId = setInterval(async () => {
      if (handled) return;
      try {
        const response = await fetch(
          `${baseUrl}/payment/check?transactionRef=${transactionRef}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken2}`,
            },
          },
        );
        if (response.ok) {
          const data = await response.json();
          const status = (data?.data?.status || "").toLowerCase();
          if (TERMINAL.includes(status)) {
            handled = true;
            handleModalOk();
          }
        }
      } catch (e) {
        // Network error – keep polling
      }
    }, 4000);
    return () => clearInterval(intervalId);
  }, [modal1Open, transactionRef]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-close Paystack modal when payment reaches a terminal state
  useEffect(() => {
    if (!openPaystackModal || !paystackReference) return;
    const TERMINAL = [
      "successful",
      "success",
      "failed",
      "cancelled",
      "error",
      "reversed",
    ];
    let handled = false;
    const intervalId = setInterval(async () => {
      if (handled) return;
      try {
        const response = await fetch(
          `${baseUrl}/payment/check-pulse?transactionRef=${paystackReference}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken2}`,
            },
          },
        );
        if (response.ok) {
          const data = await response.json();
          const status = (data?.data?.status || "").toLowerCase();
          if (TERMINAL.includes(status)) {
            handled = true;
            handlePaystackModalClose();
          }
        }
      } catch (e) {
        // Network error – keep polling
      }
    }, 4000);
    return () => clearInterval(intervalId);
  }, [openPaystackModal, paystackReference]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOk = async () => {
    const minAmount = userCurrency.toUpperCase() === "NGN" ? 1000 : 10;

    // Validate minimum amount
    if (!amount || parseFloat(amount) < minAmount) {
      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Error",
        text: `Minimum top-up amount is ${
          userCurrency.toUpperCase() === "NGN" ? "₦1,000" : "$10"
        }`,
        icon: "error",
        customClass: {
          confirmButton: "custom-swal-button",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
        confirmButtonText: "OK",
        confirmButtonColor: "#0DC939",
      });
      return;
    }
    trackAnalyticsEvent("wallet_topup_started", {
      amount: parseFloat(amount) || undefined,
      currency: userCurrency,
    });

    setIsModalVisible(false);
    try {
      if (walletPaymentMethod === 1) {
        // FlutterWave payment
        const postData = {
          amount: amount,
          currency: userCurrency,
          country: "NG",
          description: "Wallet top up",
          payment_method: "card,mobilemoney,ussd",
          type: "TOPUP",
        };
        setTransactionAmount(amount); // Store amount for conversion tracking
        setAmount("");

        // Changed from fetch to axios
        const response = await axios.post(
          `${baseUrl}/payment/flexi-initiate`,
          await withAnalyticsMetadata(postData),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken2}`,
            },
          },
        );

        const responseData = response.data; // Axios puts the response data in the 'data' property

        if (responseData.status === "success") {
          if (responseData.data && responseData.data.link) {
            setPaymentUrl(responseData.data.link);
            setTransactionRef(responseData.data.txRef);
            setModal1Open(true);
          } else {
            Swal.fire({
              background: bgContainer,
              color: text,
              title: "Error",
              text: "Response data does not contain a link",
              icon: "error",
              customClass: {
                confirmButton: "custom-swal-button",
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: "#0DC939",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
            return;
          }
        } else {
          Swal.fire({
            background: bgContainer,
            color: text,
            title: "Error",
            text: "Failed to initialize payment",
            icon: "error",
            customClass: {
              confirmButton: "custom-swal-button",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#0DC939",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });
          return;
        }
      } else if (walletPaymentMethod === 2) {
        // PayPal payment
        const postData = {
          tx_ref: `WALLET_${Date.now()}`,
          amount: amount,
          currency: "USD",
          email: userDetails?.email || "",
          type: "TOPUP",
          stakeHolders: "NON-STAKEHOLDER",
          return_url: window.location.origin + "/payment/success",
          cancel_url: window.location.origin + "/payment/failure",
        };
        setAmount("");

        const response = await axios.post(
          `${baseUrl}/payment/paypal/create`,
          await withAnalyticsMetadata(postData),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken2}`,
            },
          },
        );

        const responseData = response.data;
        console.log("PayPal Response Data:", responseData);

        if (responseData.status === "success" && responseData.approval_url) {
          // Redirect to PayPal approval URL
          window.location.href = responseData.approval_url;
        } else {
          console.error("PayPal response does not contain approval URL");
          Swal.fire({
            background: bgContainer,
            color: text,
            title: "Error",
            text: "Failed to initialize PayPal payment",
            icon: "error",
            customClass: {
              confirmButton: "custom-swal-button",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#0DC939",
          });
        }
      } else if (walletPaymentMethod === 3) {
        // Paystack payment
        const postData = {
          amount: amount,
          currency: userCurrency.toUpperCase() === "NGN" ? "NGN" : "USD",
          type: "TOPUP",
          sessionCode: null,
          stakeHolders: null,
        };
        setTransactionAmount(amount); // Store amount for conversion tracking
        setAmount("");
        setPaystackLoading(true);

        try {
          const responseData = await initiatePaystackPayment(
            postData,
            userToken2,
          );
          console.log("Paystack Response Data:", responseData);
          if (responseData.status && responseData.data) {
            // Open Paystack payment page in modal
            setPaymentUrl(responseData.data.authorization_url);
            setPaystackReference(responseData.data.reference);
            setOpenPaystackModal(true);
            setPaystackLoading(false);
          } else {
            console.error("Paystack response invalid");
            setPaystackLoading(false);
            Swal.fire({
              background: bgContainer,
              color: text,
              title: "Error",
              text: "Failed to initialize Paystack payment",
              icon: "error",
              customClass: {
                confirmButton: "custom-swal-button",
              },
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: true,
              confirmButtonText: "OK",
              confirmButtonColor: "#0DC939",
            });
          }
        } catch (error) {
          console.error("Paystack error:", error);
          setPaystackLoading(false);
          Swal.fire({
            background: bgContainer,
            color: text,
            title: "Error",
            text: error.message || "Failed to initialize Paystack payment",
            icon: "error",
            customClass: {
              confirmButton: "custom-swal-button",
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            confirmButtonText: "OK",
            confirmButtonColor: "#0DC939",
          });
        }
      }
    } catch (error) {
      // Axios errors are typically in error.response or error.message
      console.error("An error occurred:", error);

      Swal.fire({
        background: bgContainer,
        color: text,
        title: "Error",
        text: "Failed to initialize payment",
        icon: "error",
        customClass: {
          confirmButton: "custom-swal-button",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
        confirmButtonText: "OK",
        confirmButtonColor: "#0DC939",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  };
  const handleChange = (e) => {
    const value = e.target.value;

    // Validate if the input is a positive number
    if (/^[1-9]\d*\.?\d*$/.test(value) || value === "") {
      setAmount(value); // Set the amount only if it's a positive number greater than zero
    }
  };

  const { isDark } = useTheme();
  const { token } = theme.useToken(); // Get token from useToken
  const { text, bgContainer } = token;

  const handleGetStarted = (e) => {
    e.preventDefault();
    closeMobileMenu();
    if (window.location.pathname === "/") {
      const el = document.getElementById("verification-services");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#verification-services";
    }
  };

  if (!isAuthenticated) {
    return (
      <>
        <PublicNav>
          <PublicNavInner>
            <Link to="/">
              <img
                src={isDark ? LogoWhite : Logo}
                alt="Logo"
                width={140}
                style={{ marginTop: "10px", cursor: "pointer" }}
              />
            </Link>

            <PublicCenter>
              <Dropdown overlay={servicesMenu} trigger={["click"]} arrow>
                <PublicTrigger type="button">
                  Services <DownOutlined className="chev" />
                </PublicTrigger>
              </Dropdown>

              <PublicAnchor href="/#how-it-works">How it works</PublicAnchor>
              <PublicAnchor href="/#verification-services">
                Pricing
              </PublicAnchor>
              <PublicNavLink to="/faq">FAQ</PublicNavLink>
              <PublicNavLink to="/contact">Support</PublicNavLink>
            </PublicCenter>

            <PublicActions>
              {isVerificationLogin && (
                <PublicBackButton
                  type="button"
                  onClick={handleGoBack}
                  aria-label="Go Back"
                  title="Go Back"
                >
                  <FaArrowLeft aria-hidden="true" />
                  <span>Go Back</span>
                </PublicBackButton>
              )}
              <PublicHeaderLanguage>
                <PublicLanguageToggleGroup />
              </PublicHeaderLanguage>
              <Dropdown overlay={countryMenu} trigger={["click"]} arrow>
                <CountryPill type="button" aria-label="Select country">
                  <span className="flag" role="img" aria-label="Nigeria flag">
                    🇳🇬
                  </span>
                  Nigeria
                  <DownOutlined className="chev" />
                </CountryPill>
              </Dropdown>
              <PublicDesktopOnly>
                <ThemeToggle />
              </PublicDesktopOnly>
              <PublicCta href="/verification-login">
                Sign In / Register
              </PublicCta>
              <PublicHamburger onClick={handleClick} aria-label="Open menu">
                {click ? <FaTimes /> : <FaBars />}
              </PublicHamburger>
            </PublicActions>
          </PublicNavInner>

          <PublicMobilePanel $open={click}>
            <PublicMobileMenu>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "6px 0",
                }}
              >
                <ThemeToggle />
              </div>

              <PublicMobileAnchor
                href="/#how-it-works"
                onClick={closeMobileMenu}
              >
                How it works
              </PublicMobileAnchor>

              <PublicMobileLink to="/faq" onClick={closeMobileMenu}>
                FAQ
              </PublicMobileLink>
              <PublicMobileLink to="/contact" onClick={closeMobileMenu}>
                Support
              </PublicMobileLink>
              <PublicMobileAnchor href="/verification-login">
                Sign In / Register
              </PublicMobileAnchor>

              {/* Country selector for mobile */}
              <div
                style={{
                  borderTop: "1px solid rgba(17, 24, 39, 0.08)",
                  paddingTop: "14px",
                  marginTop: "4px",
                }}
              >
                <MobileCountryToggle
                  type="button"
                  onClick={() => setMobileCountryOpen((prev) => !prev)}
                >
                  <span
                    role="img"
                    aria-label="Nigeria flag"
                    style={{ fontSize: "20px" }}
                  >
                    🇳🇬
                  </span>
                  Nigeria
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: "12px",
                      transition: "transform 0.2s",
                      transform: mobileCountryOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      display: "inline-block",
                    }}
                  >
                    ▾
                  </span>
                </MobileCountryToggle>
                <MobileCountryList $open={mobileCountryOpen}>
                  {OTHER_COUNTRIES.map((country) => (
                    <MobileCountryLink
                      key={country.key}
                      href={country.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeMobileMenu}
                    >
                      <span
                        role="img"
                        aria-label={`${country.label} flag`}
                        style={{ fontSize: "20px" }}
                      >
                        {country.flag}
                      </span>
                      {country.label}
                    </MobileCountryLink>
                  ))}
                </MobileCountryList>
              </div>
            </PublicMobileMenu>
          </PublicMobilePanel>
        </PublicNav>
      </>
    );
  }

  return (
    <>
      <Spin
        spinning={paystackLoading}
        size="large"
        tip="Loading Paystack payment..."
        fullscreen
      />
      <IconContext.Provider value={{ color: "#000" }}>
        <Nav $token={token}>
          <NavbarContainer>
            <Link to="/">
              {/* <Logo style={{ marginTop: "10px" }} /> */}
              <img
                src={isDark ? LogoWhite : Logo}
                alt="Logo"
                width={230}
                style={{ marginTop: "10px", cursor: "pointer" }}
              />
            </Link>
            <HamburgerIcon onClick={handleClick}>
              {click ? (
                <FaTimes />
              ) : (
                <FaBars color={isDark ? "white" : "black"} />
              )}
            </HamburgerIcon>

            <NavMenu onClick={handleClick} click={click}>
              {isAuthenticated && (
                <>
                  <NavItemBtn>
                    <NavBtnLink to="/main-dashboard">
                      <OutlineButton
                        type="primary"
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "700",
                        }}
                        $token={token}
                      >
                        View Dashboard
                      </OutlineButton>
                    </NavBtnLink>
                  </NavItemBtn>
                  <NavItemBtn>
                    <NavBtnLink to="/">
                      <MainButton
                        type="primary"
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "700",
                        }}
                      >
                        Verify Now
                      </MainButton>
                    </NavBtnLink>
                  </NavItemBtn>
                </>
              )}
              {!isAuthenticated && (
                <>
                  <NavItemBtn>
                    <NavBtnLink to="/verification-login">
                      <OutlineButton
                        $token={token}
                        type="primary"
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "700",
                        }}
                      >
                        Sign In / Register
                      </OutlineButton>
                    </NavBtnLink>
                  </NavItemBtn>
                  <ThemeToggle />
                </>
              )}

              {/* Conditionally render logout button when the user is authenticated */}
              {window.innerWidth <= 960
                ? isAuthenticated && (
                    <>
                      {/* <NavItemBtn>
                        <NavBtnLink to="/main-dashboard">
                          <MainButton type="primary">Dashboard</MainButton>
                        </NavBtnLink>
                      </NavItemBtn> */}
                      <NavItemBtn>
                        <NavBtnLink to="/profile">
                          <MainButton type="primary">My Profile</MainButton>
                        </NavBtnLink>
                      </NavItemBtn>
                      <NavItemBtn>
                        <NavBtnLink to="/contact">
                          <MainButton type="primary">Contact Us</MainButton>
                        </NavBtnLink>
                      </NavItemBtn>
                      <NavItemBtn>
                        <NavBtnLink to="/faq">
                          <MainButton type="primary">FAQs</MainButton>
                        </NavBtnLink>
                      </NavItemBtn>
                      <div
                        style={{
                          marginTop: "20px",
                          textAlign: "center",
                          paddingLeft: "35px",
                          paddingRight: "15px",
                          color: "#FFFFFF",
                        }}
                      >
                        <Title level={4} style={{ color: "#FFFFFF" }}>
                          {userDetails?.firstName} {userDetails?.lastName}
                        </Title>
                        <p onClick={showModal} style={{ color: "#FFFFFF" }}>
                          Wallet Balance:
                          <span style={{ color: "#0DC939" }}>
                            {" "}
                            {userCurrency === "USD" || userCurrency === "usd"
                              ? `${formatToDollar(userBalance)}`
                              : formatToNaira(userBalance)}
                          </span>
                        </p>
                        <Modal
                          title="User Wallet"
                          open={isModalVisible}
                          onOk={handleOk}
                          okText="Proceed to Payment"
                          onCancel={handleCancel}
                          width={300}
                        >
                          <Title level={5}> Wallet Balance:</Title>
                          <Title level={3} style={{ color: "#0DC939" }}>
                            {userCurrency.toUpperCase() === "NGN"
                              ? formatToNaira(userBalance)
                              : `${formatToDollar(userBalance)}`}
                          </Title>

                          <Divider style={{ border: "1px solid #D9D9D9" }} />
                          <Title level={5}>Fund Wallet</Title>
                          <Title level={5}>Select Payment Method</Title>
                          <Radio.Group
                            value={walletPaymentMethod}
                            onChange={(e) =>
                              setWalletPaymentMethod(e.target.value)
                            }
                            style={{ width: "100%", marginBottom: "15px" }}
                          >
                            <Radio
                              value={1}
                              style={{
                                display: "block",
                                border: "1px solid #e8e8e8",
                                borderRadius: "5px",
                                padding: "10px",
                                marginBottom: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              FlutterWave
                            </Radio>
                            <Radio
                              value={3}
                              disabled={userCurrency.toUpperCase() === "USD"}
                              style={{
                                display: "block",
                                border: "1px solid #e8e8e8",
                                borderRadius: "5px",
                                padding: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Paystack{" "}
                              {userCurrency.toUpperCase() === "USD" &&
                                "(Not available for USD)"}
                            </Radio>
                          </Radio.Group>
                          <p>
                            Enter Amount to Fund Wallet (Minimum:{" "}
                            {userCurrency.toUpperCase() === "NGN"
                              ? "₦1,000"
                              : "$2"}
                            )
                          </p>
                          <Input
                            type="number"
                            placeholder={`Enter amount (min: ${
                              userCurrency.toUpperCase() === "NGN"
                                ? "1000"
                                : "2"
                            })`}
                            value={amount}
                            onChange={handleChange}
                            min={
                              userCurrency.toUpperCase() === "NGN" ? 1000 : 2
                            }
                          />
                          {amount &&
                            parseFloat(amount) <
                              (userCurrency.toUpperCase() === "NGN"
                                ? 1000
                                : 2) && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                Minimum top-up amount is{" "}
                                {userCurrency.toUpperCase() === "NGN"
                                  ? "₦1,000"
                                  : "$2"}
                              </p>
                            )}
                        </Modal>
                        <Modal
                          style={{
                            top: 20,
                          }}
                          width={1000}
                          open={modal1Open}
                          onOk={handleModalOk}
                          onCancel={handleModalOk}
                          maskClosable={false}
                          footer={[
                            <Button
                              style={{ color: text }}
                              type="dashed"
                              onClick={handleModalOk}
                            >
                              Close
                            </Button>,
                          ]}
                        >
                          <iframe
                            id="inlineFrameExample"
                            title="Inline Frame Example"
                            width="100%"
                            height="600"
                            src={paymentUrl}
                          ></iframe>
                        </Modal>
                        <Modal
                          style={{
                            top: 20,
                          }}
                          width={1000}
                          open={openPaystackModal}
                          onOk={handlePaystackModalClose}
                          onCancel={handlePaystackModalClose}
                          maskClosable={false}
                          footer={[
                            <Button
                              style={{ color: text }}
                              type="dashed"
                              onClick={handlePaystackModalClose}
                            >
                              Close
                            </Button>,
                          ]}
                        >
                          <iframe
                            id="paystackPaymentFrame"
                            title="Paystack Payment"
                            width="100%"
                            height="600"
                            src={paymentUrl}
                          ></iframe>
                        </Modal>
                      </div>

                      <NavItemBtn>
                        <NavBtnLink>
                          <OutlineButton
                            type="primary"
                            onClick={handleLogout}
                            $token={token}
                          >
                            Logout
                          </OutlineButton>
                        </NavBtnLink>
                      </NavItemBtn>

                      <div
                        style={{
                          paddingLeft: "49px",
                          paddingRight: "15px",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <MobileCountryToggle
                          type="button"
                          onClick={() => setMobileCountryOpen((prev) => !prev)}
                          style={{ color: "#FFFFFF" }}
                        >
                          <span role="img" aria-label="Nigeria flag">
                            🇳🇬
                          </span>
                          Nigeria
                          <span
                            style={{
                              marginLeft: "auto",
                              fontSize: "12px",
                              transition: "transform 0.2s",
                              transform: mobileCountryOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              display: "inline-block",
                            }}
                          >
                            ▾
                          </span>
                        </MobileCountryToggle>
                        <MobileCountryList $open={mobileCountryOpen}>
                          {OTHER_COUNTRIES.map((country) => (
                            <MobileCountryLink
                              key={country.key}
                              href={country.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={closeMobileMenu}
                              style={{ color: "#FFFFFF" }}
                            >
                              <span
                                role="img"
                                aria-label={`${country.label} flag`}
                              >
                                {country.flag}
                              </span>
                              {country.label}
                            </MobileCountryLink>
                          ))}
                        </MobileCountryList>
                      </div>

                      <ThemeToggle style={{ paddingLeft: "49px" }} />
                    </>
                  )
                : isAuthenticated && (
                    <>
                      <div
                        style={{
                          marginTop: "20px",
                          textAlign: "end",
                          paddingLeft: "35px",
                          paddingRight: "15px",
                        }}
                      >
                        <Title level={4}>
                          {userDetails?.firstName} {userDetails?.lastName}
                        </Title>
                        <p onClick={showModal} style={{ color: text }}>
                          Wallet Balance:
                          <span style={{ color: "#0DC939" }}>
                            {" "}
                            {userCurrency === "USD" || userCurrency === "usd"
                              ? `${formatToDollar(userBalance)}`
                              : formatToNaira(userBalance)}
                          </span>
                        </p>
                        <Modal
                          title="User Wallet"
                          open={isModalVisible}
                          onOk={handleOk}
                          okText="Proceed to Payment"
                          onCancel={handleCancel}
                          width={300}
                        >
                          <Title level={5}> Wallet Balance:</Title>
                          <Title level={3} style={{ color: "#0DC939" }}>
                            {userCurrency.toUpperCase() === "NGN"
                              ? formatToNaira(userBalance)
                              : `${formatToDollar(userBalance)}`}
                          </Title>

                          <Divider style={{ border: "1px solid #D9D9D9" }} />
                          <Title level={5}>Fund Wallet</Title>
                          <Title level={5}>Select Payment Method</Title>
                          <Radio.Group
                            value={walletPaymentMethod}
                            onChange={(e) =>
                              setWalletPaymentMethod(e.target.value)
                            }
                            style={{ width: "100%", marginBottom: "15px" }}
                          >
                            <Radio
                              value={1}
                              style={{
                                display: "block",
                                border: "1px solid #e8e8e8",
                                borderRadius: "5px",
                                padding: "10px",
                                marginBottom: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              FlutterWave
                            </Radio>
                            <Radio
                              value={3}
                              disabled={userCurrency.toUpperCase() === "USD"}
                              style={{
                                display: "block",
                                border: "1px solid #e8e8e8",
                                borderRadius: "5px",
                                padding: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Paystack{" "}
                              {userCurrency.toUpperCase() === "USD" &&
                                "(Not available for USD)"}
                            </Radio>
                          </Radio.Group>
                          <p>
                            Enter Amount to Fund Wallet (Minimum:{" "}
                            {userCurrency.toUpperCase() === "NGN"
                              ? "₦1,000"
                              : "$2"}
                            )
                          </p>
                          <Input
                            type="number"
                            placeholder={`Enter amount (min: ${
                              userCurrency.toUpperCase() === "NGN"
                                ? "1000"
                                : "2"
                            })`}
                            value={amount}
                            onChange={handleChange}
                            min={
                              userCurrency.toUpperCase() === "NGN" ? 1000 : 2
                            }
                          />
                          {amount &&
                            parseFloat(amount) <
                              (userCurrency.toUpperCase() === "NGN"
                                ? 1000
                                : 2) && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                Minimum top-up amount is{" "}
                                {userCurrency.toUpperCase() === "NGN"
                                  ? "₦1,000"
                                  : "$2"}
                              </p>
                            )}
                        </Modal>
                        <Modal
                          style={{
                            top: 20,
                          }}
                          width={1000}
                          open={modal1Open}
                          onOk={handleModalOk}
                          onCancel={handleModalOk}
                          maskClosable={false}
                          footer={[
                            <Button
                              danger
                              type="dashed"
                              onClick={handleModalOk}
                            >
                              Close
                            </Button>,
                          ]}
                        >
                          <iframe
                            id="inlineFrameExample"
                            title="Inline Frame Example"
                            width="100%"
                            height="600"
                            src={paymentUrl}
                          ></iframe>
                        </Modal>
                        <Modal
                          style={{
                            top: 20,
                          }}
                          width={1000}
                          open={openPaystackModal}
                          onOk={handlePaystackModalClose}
                          onCancel={handlePaystackModalClose}
                          maskClosable={false}
                          footer={[
                            <Button
                              danger
                              type="dashed"
                              onClick={handlePaystackModalClose}
                            >
                              Close
                            </Button>,
                          ]}
                        >
                          <iframe
                            id="paystackPaymentFrame"
                            title="Paystack Payment"
                            width="100%"
                            height="600"
                            src={paymentUrl}
                          ></iframe>
                        </Modal>
                      </div>
                      <UserDropdown />
                      <div style={{ marginLeft: "20px" }}></div>
                    </>
                  )}
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
